import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/staticSeo/images/my-user-avatar.png")